export const isServer = !process.browser;
